/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentV1PropertiesPropertyIdFavoriteDelete422Response model module.
 * @module model/AgentV1PropertiesPropertyIdFavoriteDelete422Response
 * @version 1.0.0
 */
class AgentV1PropertiesPropertyIdFavoriteDelete422Response {
    /**
     * Constructs a new <code>AgentV1PropertiesPropertyIdFavoriteDelete422Response</code>.
     * @alias module:model/AgentV1PropertiesPropertyIdFavoriteDelete422Response
     */
    constructor() { 
        
        AgentV1PropertiesPropertyIdFavoriteDelete422Response.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentV1PropertiesPropertyIdFavoriteDelete422Response</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentV1PropertiesPropertyIdFavoriteDelete422Response} obj Optional instance to populate.
     * @return {module:model/AgentV1PropertiesPropertyIdFavoriteDelete422Response} The populated <code>AgentV1PropertiesPropertyIdFavoriteDelete422Response</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentV1PropertiesPropertyIdFavoriteDelete422Response();

            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentV1PropertiesPropertyIdFavoriteDelete422Response</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentV1PropertiesPropertyIdFavoriteDelete422Response</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
            throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
        }

        return true;
    }


}



/**
 * @member {String} message
 */
AgentV1PropertiesPropertyIdFavoriteDelete422Response.prototype['message'] = undefined;






export default AgentV1PropertiesPropertyIdFavoriteDelete422Response;

